var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"hero-card rounded-lg",style:(_vm.background)},[_c('h1',[_vm._t("default",function(){return [_vm._v(" CARRERAS KINESIA ")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }